import io from "socket.io-client";
import { getBackendUrl } from "../config";

let socket = null;

const readToken = () => {
  const raw = localStorage.getItem("token");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return raw;
  }
};

export function getSocket() {
  const token = readToken();
  if (!token) return socket;

  if (socket) return socket;

  socket = io(getBackendUrl(), {
    transports: ["websocket"],
    query: { token },
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    autoConnect: true,
  });

  return socket;
}

export function disconnectSocket() {
  if (!socket) return;
  socket.removeAllListeners();
  socket.disconnect();
  socket = null;
}

export function emitWhenConnected(event, payload) {
  const s = getSocket();
  if (!s) return () => {};
  const emit = () => s.emit(event, payload);
  if (s.connected) emit();
  s.on("connect", emit);
  return () => s.off("connect", emit);
}

export default getSocket;
